import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IScheduledCampaign } from '../../data/interfaces/scheduled-campaign.interface';
import { METRICS_CONFIG } from '../../data/constants/campaigns.constants';

@Component({
  selector: 'app-campaign-metrics',
  templateUrl: './campaign-metrics.component.html',
  styleUrls: ['./campaign-metrics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignMetricsComponent {
  @Input() campaign: IScheduledCampaign | null = null;
  
  metricsConfig = METRICS_CONFIG;
  
  get metrics(): { [key: string]: number } {
    return this.campaign?.metrics || {
      totalSent: 0,
      successful: 0,
      failed: 0,
      pending: 0
    };
  }

  getSuccessRate(): number {
    const total = this.metrics['totalSent'] || 0;
    const successful = this.metrics['successful'] || 0;
    
    if (total === 0) return 0;
    
    return Math.round((successful / total) * 100);
  }
}
